import { Burger, Scrollbar } from '../core'

export default {

  init() {

    /* Burger */
    let obj = this
    obj.burger = new Burger('.header__burger', {
      onToggle: function() {
        if (obj.burger.isExpanded) {
          $('body').addClass('--menu-open')
        } else {
          $('body').removeClass('--menu-open')
        }
      },
    })

    $('.js-toggle-search').click(function() {
      let $popup = $(this)
      $(this).toggleClass('--opened')
      if ($('body').hasClass('--search-open')) {
        $('body').removeClass('--search-open');
      } else {
        $('body').addClass('--search-open');
      }
    })

    $(window).on('resize load orientationchange', menuHeight)
    menuHeight()

    if (window.location.pathname.includes('/sujet/')) {
      const $confLink = $('.main-menu a[href*="/conferences/"]')

      if ($confLink.length) {
        $confLink.closest('li').addClass('main-menu__item--active')
      }
    }
  }
}
